import React from 'react';
import { Play } from 'lucide-react';

const VideoTutorial = () => {
  return (
    <section className="py-20 bg-[#F0F0F0]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-6">
              Kalian pasti penasaran gimana cara pake{' '}
              <span className="text-[#ED1C24]">Indikator SBE</span> kan?
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Arep akan tunjukin kalian gimana caranya untuk baca market dengan lebih gampang
            </p>
          </div>
          
          <div className="bg-gradient-to-br from-[#1a1a1a] to-black rounded-3xl p-6 md:p-8 border-2 border-[#ED1C24] shadow-2xl">
            <div className="relative w-full mx-auto" style={{ maxWidth: '800px', aspectRatio: '16/9' }}>
              <video
                src="https://customer-assets.emergentagent.com/job_signal-bank/artifacts/lpllrb58_INDICAATOR%20SBE%20CARA%20GUNA%20BARU.mp4"
                controls
                playsInline
                webkit-playsinline="true"
                x5-playsinline="true"
                preload="metadata"
                className="w-full h-full rounded-2xl object-cover"
                poster="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 800 450'%3E%3Crect fill='%23000' width='800' height='450'/%3E%3Ctext fill='%23ED1C24' font-size='24' font-family='Arial' x='50%25' y='50%25' text-anchor='middle' dominant-baseline='middle'%3ETutorial Indikator SBE%3C/text%3E%3C/svg%3E"
              >
                Browser kamu tidak support video player.
              </video>
            </div>
            
            <div className="mt-6 md:mt-8 grid grid-cols-3 md:grid-cols-3 gap-3 md:gap-6 max-w-md md:max-w-none mx-auto">
              <div className="bg-[#ED1C24]/10 border border-[#ED1C24]/30 rounded-lg md:rounded-xl p-2 md:p-4 text-center">
                <div className="w-8 h-8 md:w-12 md:h-12 bg-[#ED1C24] rounded-full flex items-center justify-center mx-auto mb-1 md:mb-3">
                  <span className="text-white font-bold text-sm md:text-xl">1</span>
                </div>
                <p className="text-white font-semibold text-xs md:text-base">Setup Indikator</p>
              </div>
              
              <div className="bg-[#ED1C24]/10 border border-[#ED1C24]/30 rounded-lg md:rounded-xl p-2 md:p-4 text-center">
                <div className="w-8 h-8 md:w-12 md:h-12 bg-[#ED1C24] rounded-full flex items-center justify-center mx-auto mb-1 md:mb-3">
                  <span className="text-white font-bold text-sm md:text-xl">2</span>
                </div>
                <p className="text-white font-semibold text-xs md:text-base">Baca Sinyal Entry</p>
              </div>
              
              <div className="bg-[#ED1C24]/10 border border-[#ED1C24]/30 rounded-lg md:rounded-xl p-2 md:p-4 text-center">
                <div className="w-8 h-8 md:w-12 md:h-12 bg-[#ED1C24] rounded-full flex items-center justify-center mx-auto mb-1 md:mb-3">
                  <span className="text-white font-bold text-sm md:text-xl">3</span>
                </div>
                <p className="text-white font-semibold text-xs md:text-base">Eksekusi & Profit</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoTutorial;